module.exports = __webpack_public_path__ + "static/img/5areaB_2.891a07c.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/5areaB_2.png
// module id = 1194
// module chunks = 1